import styled from 'styled-components';
import { useIsModernizedSegmentationPageEnabled } from 'modules/segmentation/hooks';
import { textColors, letterSpacing, fontSizes, colors, spacing, fontWeights } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { Link } from 'ui/links';
import { Cell } from '../../components/table';
import { TABLE_COLUMNS } from '../constants';
import { List } from '../../domain/list';

interface ListNameCellProps {
  list: List;
}

const CellWrapper = styled(Cell)`
  height: ${pxToRem(90)};
  width: 100%;
`;

export const MetaDataWrapper = styled.div`
  color: ${textColors.textSecondary};
  display: grid;
  grid-template-columns: max-content 1fr;
  font-size: ${fontSizes.s12};
  height: fit-content;
  letter-spacing: ${letterSpacing.pos10};

  /** unicode for bullet operators */

  > * + * {
    :before {
      color: ${colors.grey35};
      content: '\\2219'; /** unicode for bullet operators */
      margin-right: ${spacing.quarter};
      font-weight: ${fontWeights.semiBold};
    }
    margin-left: ${spacing.quarter};
  }
`;

export const Description = styled.span`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const DATA_TEST = {
  cell: 'list-name-cell',
  description: 'list-description',
};

export const ListNameCell = ({ list }: ListNameCellProps) => {
  const { id, name, description } = list;
  const isModernizedSegmentationPageEnabled = useIsModernizedSegmentationPageEnabled();
  return (
    <CellWrapper columnId={TABLE_COLUMNS.NAME} data-test={DATA_TEST.cell}>
      <Link
        inTable
        href={`/segmentation?emailListId=${id}`}
        target="_blank"
        useReactRouter={isModernizedSegmentationPageEnabled}
        rel={isModernizedSegmentationPageEnabled ? 'noopener noreferrer' : undefined}
      >
        {name}
      </Link>
      <MetaDataWrapper>
        <span>{`ID: ${id}`}</span>
        {description && <Description data-test={DATA_TEST.description}>{description}</Description>}
      </MetaDataWrapper>
    </CellWrapper>
  );
};
